var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loading-spinner',{attrs:{"full-page":""}}):(_vm.showBeforeYouBegin)?_c('cosign-before-you-begin'):(_vm.noCosignSource)?_c('no-cosign-source'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }